import BenchlingConfig from 'BenchlingConfig';
import StringResolutionManager from 'models/managers/StringResolutionManager';
import {
  DedicatedLookupStructuredTableColumn,
  StructuredTable,
} from 'notebook/structured-tables/StructuredTableConstants';
import {removeQueryResolutionsFromSnapshot} from 'notebook/tables/excess/Resolver';
import {CustomResolutionQueryType} from 'notebook/tables/string-resolution/StringResolutionConstants';
import {TableColumnType} from 'notebook/tables/TableConstants';

export function handleRefreshLookupStructuredTable({
  entryOrTemplateId,
  structuredTable,
}: {
  entryOrTemplateId: string;
  structuredTable: StructuredTable<unknown, unknown>;
}): void {
  const columns = structuredTable.columns.filter(
    (column) => column.columnType === TableColumnType.DEDICATED_LOOKUP
  ) as Array<DedicatedLookupStructuredTableColumn>;
  handleRefreshLookupColumns({
    entryOrTemplateId,
    tableProvenanceUuid: structuredTable.provenanceUuid,
    columns,
  });
}

export function handleRefreshLookupColumns({
  entryOrTemplateId,
  tableProvenanceUuid,
  columns,
}: {
  entryOrTemplateId: string;
  tableProvenanceUuid: string;
  columns: Array<DedicatedLookupStructuredTableColumn>;
}): void {
  const lookupConfigIds = columns.map((column) => column.lookupConfig.id);
  // Clear potentially stale string resolution query cache if rendering from note runtime snapshots
  if (BenchlingConfig.ELN_ENABLE_RUNTIME_SNAPSHOT_RENDER) {
    StringResolutionManager.clearStringResolutionReduxCacheByTypeAndId(
      CustomResolutionQueryType.LOOKUP_COLUMN,
      lookupConfigIds
    );
  }

  // Delete potentially stale lookup column queryResolutions from snapshot if snapshot eval is enabled
  if (BenchlingConfig.ELN_ENABLE_RUNTIME_SNAPSHOT_EVAL) {
    removeQueryResolutionsFromSnapshot(entryOrTemplateId, tableProvenanceUuid, lookupConfigIds);
  }
}
